
export default {
  productData: {
    serialNumber: 'DA-HMUF-004',
    name: 'Holzbalkendecken mit Unterdecken an Federschienen | Aufbau 4',
    construction: {
      composition: [
        {
          type: 'screed',
          title: { de: 'Estrich' },
          output: '≥ 50',
          value: 'w-50'
        },
        {
          type: 'insulation',
          title: { de: 'Holzfaserdämmplatte WF<br>(<i>s‘</i> ≤ 20 MN/m<sup>3</sup>; Anwendungsgebiet DES-sg)' },
          output: '≥ 30',
          value: 'w-30'
        },
        {
          type: 'fill',
          title: { de: 'Mit StoPrefa Coll SB gebundene Schüttung (<i>m‘</i> ≥ 75 kg/m<sup>2</sup>), ggf. Rieselschutz' },
          output: '≥ 50',
          value: 'scsb-50'
        },
        {
          type: 'woodenPanel',
          title: { de: 'Holzwerkstoffplatte HW' },
          output: '22',
          value: 22
        },
        {
          type: 'supportingStructure',
          title: { de: 'Balken oder Stegträger' },
          output: '220',
          value: 'bs-220'
        },
        {
          type: 'suspendedCeiling',
          title: { de: 'Hohlraumdämpfung' },
          output: '100',
          value: 'h-100'
        },
        {
          type: 'suspendedCeiling',
          title: { de: 'Federschiene' },
          output: '27',
          value: 'f-27'
        },
        {
          type: 'suspendedCeiling',
          title: { de: 'Gipsplatte GK' },
          output: '12,5',
          value: 'g-12.5'
        }
      ],
      sum: {
        output: '411,5', value: 411.5
      }
    },
    technicalValues: {
      impactSoundLevel: { // L,nw
        output: '40 (-1)',
        value: 40
      },
      soundReductionIndex: { // Rw
        output: '≥ 70',
        value: 70
      },
      heatTransferCoefficient: { // U-Wert
        output: '0,27',
        value: 0.27
      },
      fireResistance: {
        output: 'F 30-B',
        value: 'F-30-B'
      },
      massPerUnitArea: {
        output: '247,6 [kg/m²]'
      }
    }
  },
  image: 'da-hmuf-004.png',
  pdf: 'Holzbalkendecken-mit-Unterdecken-an-Federschiene-Aufbau-4-DA-HMUF-004-Rev03.pdf'
}
